export default __webpack_public_path__ + "static/media/DavidDesktop.420bc3e5.png";